"use client";

import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LodgingOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [progress, setProgress] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const images = ["https://wildflyfishingnm.com/wp-content/uploads/2026/03/IMG_9410-scaled.jpg", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/cozy_cabin_interior.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/sunset_river_balcony.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/rustic_bedroom_comfort.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/riverside_terrace_seating.png"];
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) return 0;
          return prev + 0.5;
        });
      }, 30);
      return () => clearInterval(interval);
    }
  }, [isHovered]);
  return <section id="lodging-overview" ref={ref} className="relative bg-background py-[var(--space-3xl)] overflow-hidden">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[var(--space-3xl)] items-center">
          {}
          <div className="space-y-[var(--space-xl)]">
            <div className={`space-y-[var(--space-md)] ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
              <h2 className="text-4xl md:text-5xl font-display text-foreground leading-tight">
                Riverside
              </h2>
            </div>
            <div className={`space-y-[var(--space-md)] ${isVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
              <h3 className="text-3xl md:text-4xl font-display text-foreground/90 leading-tight">
                Comfort
              </h3>
            </div>
            <div className={`space-y-[var(--space-md)] ${isVisible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-md">
                Unwind in our thoughtfully designed lodgings that blend rustic charm with modern amenities, offering stunning river views and serene natural surroundings.
              </p>
            </div>
          </div>

          {}
          <div className={`relative ${isVisible ? "animate-fade-in-up-delay-300" : "opacity-0"}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <Carousel opts={{
            loop: true,
            duration: 30
          }} className="w-full">
              <CarouselContent>
                {images.map((img, i) => <CarouselItem key={i} data-index={i}>
                    <div className="relative aspect-[4/3] overflow-hidden rounded-[3rem] shadow-strong">
                      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-secondary/10 mix-blend-overlay" />
                      <img src={img} alt={`Lodging view ${i + 1}`} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02]" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>

            {}
            <div className="mt-[var(--space-lg)] px-[var(--space-md)]">
              <Progress value={progress} className="h-1 bg-muted" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}